export class CTRL_NAME_EXTRACTOR {

    public static getCtrlNames(form, filter): string[] {
        const controls: string[] = [];
        Object.keys(form.controls).forEach((key) => {
            if (key.indexOf(filter) != -1) {
                controls.push(key);
            }
        });
        return controls;
    }
}